import {useApi} from "../Api";
import {
    IReportBarChart,
    IReportCompetitorsBenchmarkBE,
    IReportDateCarGroup,
    IReportRegionLocationMonth,
    IReportRegionMonth,
    IReportUtilizationAndAvailability,
    ReportAverageRpdRequest,
    ReportCompetitorsBenchmarkRequest,
    ReportIncomingReservationRequest,
    ReportNumberOfDaysOfReservationRequest,
    ReportNumberOfReservationCarGroupsRequest,
    ReportNumberOfReservationsRequest,
    ReportRevenuesRequest,
    ReportUtilizationAndAvailabilityRequest
} from "../types/report";
import {buildQueryParams} from "../../utils";
import {Location} from "../types/location";

export const useReportsRepository = () => {
    const {GET, POST} = useApi();

    const PATH = "pricing/report";

    // Report 1
    function postReportIncomingReservation(inputParams: ReportIncomingReservationRequest): Promise<IReportBarChart[]> {
        return POST(`${PATH}/average-reservation-day`, inputParams);
    }

    // Report 2
    function getReportCompetitorsBenchmark(inputParams: ReportCompetitorsBenchmarkRequest): Promise<IReportCompetitorsBenchmarkBE[]> {
        const query = "?";

        const queryParams = buildQueryParams(inputParams);

        return GET(`${PATH}/competitors${queryParams ? query + queryParams : ""}`);
    }

    // Report 3
    function getReportNumberOfReservations(inputParams: ReportNumberOfReservationsRequest): Promise<IReportRegionLocationMonth[]> {
        const query = "?";

        const queryParams = buildQueryParams(inputParams);

        return GET(`${PATH}/numbers-reservation${queryParams ? query + queryParams : ""}`);
    }

    // Report 4
    function postReportNumberOfDaysOfReservation(inputParams: ReportNumberOfDaysOfReservationRequest): Promise<IReportRegionMonth[]> {
        return POST(`${PATH}/duration-location-group`, inputParams);
    }

    // Report 5
    function postReportAverageRpd(inputParams: ReportAverageRpdRequest): Promise<IReportRegionMonth[]> {
        return POST(`${PATH}/average-location-group`, inputParams);
    }

    // Report 6
    function postReportRevenues(inputParams: ReportRevenuesRequest): Promise<IReportRegionMonth[]> {
        return POST(`${PATH}/revenue-location-group`, inputParams);
    }

    // Report 7
    function getReportNumberOfReservationsCarGroups(inputParams: ReportNumberOfReservationCarGroupsRequest): Promise<IReportDateCarGroup[]> {
        const query = "?";

        const queryParams = buildQueryParams(inputParams);

        return GET(`${PATH}/number-reservations-booking-date-car-groups${queryParams ? query + queryParams : ""}`);
    }

    // Report 8
    function getReportUtilizationAndAvailability(inputParams: ReportUtilizationAndAvailabilityRequest): Promise<IReportUtilizationAndAvailability> {
        const query = "?";

        const queryParams = buildQueryParams(inputParams);

        return GET(`${PATH}/utilization${queryParams ? query + queryParams : ""}`);
    }

    function getMonthsEnum(): Promise<string[]> {
        return GET(`${PATH}/util/months`);
    }

    function getOffices(tenant: string): Promise<string[]> {
        return GET(`${PATH}/offices?tenant=${tenant}`);
    }

    function getSites(tenant: string): Promise<string[]> {
        return GET(`${PATH}/sites?tenant=${tenant}`);
    }

    function getLocationReport(legalEntites:string): Promise<Location[]> {
        return GET(`${PATH}/location-pool?legalEntity=${legalEntites}`);
    }

    return {
        postReportIncomingReservation,
        getReportCompetitorsBenchmark,
        postReportAverageRpd,
        getReportNumberOfReservations,
        postReportRevenues,
        postReportNumberOfDaysOfReservation,
        getReportNumberOfReservationsCarGroups,
        getReportUtilizationAndAvailability,
        getMonthsEnum,
        getOffices,
        getSites,
        getLocationReport
    };
};
